import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import {
  getOrganizations,
  organizationSelector,
  ORGANIZATIONS_QUERY_CONFIG,
  ORGANIZATIONS_QUERY_KEY,
} from '../api';
import type { OrganizationId } from '../dto';
import type { Organization } from '../model';

type UserId = Parameters<typeof getOrganizations>[0];

export function useOrganization(
  organizationId: OrganizationId | undefined,
  /* NOTE: user ID is only needed here because of the API we used; it might be derived from the session
     The parameter is optional because of the userId sometimes comes from another hook and it's delivered asynchronously
     And hooks cannot be conditional obviously.
   */
  userId: UserId | undefined,
): UseQueryResult<Organization, Error> {
  return useQuery([ORGANIZATIONS_QUERY_KEY, userId], () => getOrganizations(userId as UserId), {
    select: organizationSelector(organizationId as OrganizationId),
    enabled: typeof userId !== 'undefined',
    ...ORGANIZATIONS_QUERY_CONFIG,
  });
}
